export default __webpack_public_path__ + "static/media/eye.41b81c15.svg";